import Vue from 'vue'
//import store from '~/store'
import VueI18n from './vue-i18n'

Vue.use(VueI18n)

import { localRead} from '../store/lang'

import langEnUs from '../lang/en_US.json'
import langTHth from '../lang/th_TH.json'
import langLoLA from '../lang/lo_LA.json'
import langZhCN from '../lang/zh_CN.json'

const navLang = navigator.language
const localLang = (navLang === 'th-TH') ? navLang : false
let lang = localRead('local') || localLang || 'th-TH'
lang = lang.split('-')[0];

const messages = {
    en: langEnUs,
    th: langTHth,
    la: langLoLA,
    cn: langZhCN
  };

const i18n = new VueI18n({
    locale: lang,
    messages,
    silentTranslationWarn: process.env.NODE_ENV === 'production'
});

export default i18n


// WEBPACK FOOTER //
// ./src/plugins/i18n.js